import React, { useEffect, useState } from 'react'
import './NavigationBar.css'
import { AppBar, Box, Avatar, Typography, Tabs, Tab } from '@material-ui/core'
import { getUser } from '../Controller'
import { useHistory } from 'react-router-dom'
import { Page } from '../const'

export function NavigationBar() {
  const [user, setUser] = useState({ display_name: '', links: { avatar: { href: '' } } })
  const [activePage, setActivePage] = useState('Deployment')
  const history = useHistory()

  useEffect(() => {
    getUser().then(userResponse => {
      if (userResponse.success) {
        setUser(userResponse.result)
      }
    })
  }, [])

  useEffect(() => {
    switch (activePage) {
      case 'Deployment':
        history.push(Page.deployment)
        break
      case 'Merge':
        history.push(Page.merge)
        break
      default:
        history.push(Page.deployment)
        break
    }
  }, [activePage, history])

  function onHandleChange(e: any, newValue: string) {
    setActivePage(newValue)
  }

  if (user) {
    return (
      <AppBar color='primary' id='AppBar' position='static'>
        <Box id='UserInformation'>
          <Avatar className='margin-right icon-medium' src={user.links.avatar.href} />
          <Typography variant='body1'>{user.display_name}</Typography>
        </Box>
        <Box id='TabBox'>
          <Tabs value={activePage} onChange={onHandleChange} textColor='inherit'>
            <Tab value='Deployment' label='Deployment' />
            <Tab value='Merge' label='Merge' />
          </Tabs>
        </Box>
      </AppBar>
    )
  } else {
    return <AppBar color='primary' id='AppBar' position='static' />
  }
}

export default NavigationBar
